import tree from './tree'

export default {
  tree
}
